import { useEffect } from "react";


export default function usePageShow(callback) {
	useEffect(() => {
		// Reset navigating when page is restored from bfcache
		const handlePageShow = (event) => {
			if (event.persisted) callback();
		};
		window.addEventListener("pageshow", handlePageShow);
		return () => window.removeEventListener("pageshow", handlePageShow);
	}, []);
}